$(() => {
  const pathArray = window.location.pathname.split('/');

  if (!_.includes(pathArray, 'terms') && !_.includes(pathArray, 'privacy')) {
    if (!readCookie()) {

      $('html').addClass('age-gate-on');
      $('.age-gate').fadeIn(150);
    }
  }

  $('.age-gate__yes').on('click', () => {
    createAgeCookie();
  });

  function createAgeCookie() {
    let remember = $('#rememberMe');
    let expires = '';

    if (remember.is(':checked')) {
      const daysUntilExpired = 365;
      const date = new Date();
      date.setTime(date.getTime() + (daysUntilExpired * 24 * 60 * 60 * 1000));
      expires = `expires=${date.toGMTString()}`;
    }

    const domain = window.location.hostname;
    document.cookie = `ageVerified=1;${expires};path=/;`;
    $('html').removeClass('age-gate-on');
    $('.age-gate').fadeOut();
  }

  function readCookie() {
    var nameEQ = 'ageVerified=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
});
